import { useEffect, useMemo, useState } from 'react'

import { AccidentAtlasChartConfig, isCartesianChartConfig } from '../types/api'
import { AccidentAtlasChartRenderType } from '../types/tile'
import {
  CARTESIAN_CHART_PAGE_SIZE,
  getCartesianCategoryCount,
  getCartesianChartPageCount,
  shouldPaginateCartesianChart,
} from '../lib/sliceCartesianChart'

export function useColumnChartPagination(
  chart: AccidentAtlasChartConfig,
  renderType: AccidentAtlasChartRenderType,
  compactChartLayout: boolean
) {
  const [page, setPage] = useState(0)

  const paginationKey = useMemo(() => {
    if (!isCartesianChartConfig(chart)) return ''
    return `${chart.xAxis.categories.join('\0')}:${compactChartLayout}`
  }, [chart, compactChartLayout])

  useEffect(() => {
    setPage(0)
  }, [paginationKey])

  const categoryCount = isCartesianChartConfig(chart)
    ? getCartesianCategoryCount(chart)
    : 0

  const shouldPaginate =
    renderType === 'ColumnChart' &&
    isCartesianChartConfig(chart) &&
    shouldPaginateCartesianChart(categoryCount, compactChartLayout)

  const pageCount = shouldPaginate
    ? getCartesianChartPageCount(categoryCount, CARTESIAN_CHART_PAGE_SIZE)
    : 1

  const safePage = Math.min(page, pageCount - 1)
  const showNav = shouldPaginate && pageCount > 1

  return {
    setPage,
    showNav,
    pageCount,
    safePage,
    shouldPaginate,
  }
}
